import { create } from "zustand";
import { devtools } from "zustand/middleware";

import type {
  PlanOption,
  PlanSelection,
} from "@/portals/customer/types/customer-portal";

export type ProductPlanStoreActions = {
  setSelectedProductPlan: (plan: Partial<PlanOption>) => void;
  setProductPlanSelection: (plan: PlanSelection) => void;
};
export type ProductPlanStoreState = {
  selectedProductPlanOption?: Partial<Omit<PlanOption, "rate">> & {
    rate?: Partial<PlanOption["rate"]>;
  };
  productPlanOption?: PlanSelection;
};
export type ProductPlanStore = ProductPlanStoreState & ProductPlanStoreActions;

export const useProductPlanStore = create<ProductPlanStore>()(
  devtools(
    (set) => ({
      setSelectedProductPlan: (plan: Partial<PlanOption>) => {
        set({
          selectedProductPlanOption: {
            productId: plan.productId,
            productName: plan.productName,
            productLabel: plan.productLabel,
            maxBenefitLimit: plan.productId,
            planType: plan.planType,
            rate: {
              rateAmount: plan.productId,
              currency: plan.rate?.currency,
            },
            policy_prefix: plan.policy_prefix,
            travel_type_id: plan.productId,
            type_name: plan.type_name,
          },
        });
      },
      setProductPlanSelection: (plan: PlanSelection) =>
        set({ productPlanOption: plan }),
    }),
    { name: "ProductPlanStore" },
  ),
);
